import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="py-3 md:py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {isLast ? (
                <span className="text-foreground-500 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-600 transition-colors no-underline whitespace-nowrap"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-400">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}